import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import { LINKS, PROFILE } from '../../constants/links';
import { useTypedSelector } from '../../hooks/useTypesSelector';
import { useActions } from '../../hooks/useAction';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
} from '@mui/material';
import { Container } from '@mui/system';

export const Header = () => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const { isAuthorized } = useTypedSelector((state) => state.auth);
  const [close, setClose] = useState(false);
  const { logout } = useActions();
  const handlerLogout = () => {
    setAnchorElNav(null);
    logout();
  };

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setClose(() => !close);
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setClose(() => !close);
    setAnchorElUser(null);
  };

  return (
    <>
      <AppBar position="static" sx={{ backgroundColor: '#6949FF' }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <Box component="div">
              <Typography
                variant="h6"
                noWrap
                component="a"
                sx={{
                  mr: 3,
                  display: { xs: 'none', md: 'flex' },
                  fontWeight: 700,
                  letterSpacing: '.1rem',
                  color: 'inherit',
                  textDecoration: 'none',
                }}
              >
                <Link to="/"> Lingway</Link>
              </Typography>
              <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
                <IconButton
                  size="large"
                  aria-label="account of current user"
                  aria-controls="menu-appbar"
                  aria-haspopup="true"
                  onClick={handleOpenNavMenu}
                  color="inherit"
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorElNav}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  open={Boolean(anchorElNav)}
                  onClose={handleCloseNavMenu}
                  sx={{
                    display: { xs: 'block', md: 'none' },
                  }}
                >
                  {LINKS.map((link) => (
                    <MenuItem onClick={handleCloseNavMenu} key={link.id}>
                      <Typography textAlign="center">
                        <Button color="inherit">
                          <Link to={link.to}>{link.title} </Link>
                        </Button>
                      </Typography>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            </Box>

            <Typography
              variant="h5"
              noWrap
              component="a"
              href=""
              sx={{
                mr: 2,
                display: { xs: 'flex', md: 'none' },
                flexGrow: 1,
                fontWeight: 700,
                letterSpacing: '.1rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              <Link to="/"> Lingway</Link>
            </Typography>
            <Box
              sx={{
                flexGrow: 1,
                display: { xs: 'none', md: 'flex' },
                justifyContent: 'center',
                paddingRight: '115px',
              }}
            >
              {LINKS.map((link) => (
                <Button
                  variant="text"
                  component={NavLink}
                  to={link.to}
                  key={link.id}
                  sx={{
                    color: 'white',
                    display: 'block',
                    fontSize: 16,
                    paddingTop: 1,
                    '&.active': {
                      background: ' #876dff',
                    },
                  }}
                >
                  {link.title}
                </Button>
              ))}
            </Box>
            <Box sx={{ flexGrow: 0 }}>
              <Tooltip title="вход в аккаунт">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }} size="large">
                  <AccountCircleIcon fontSize="inherit" sx={{ fontSize: 30 }} />
                </IconButton>
              </Tooltip>
              <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
              >
                {isAuthorized ? (
                  <MenuItem>
                    <Button onClick={handlerLogout}>Выйти из акканута</Button>
                  </MenuItem>
                ) : (
                  PROFILE.map((link) => (
                    <MenuItem key={link.title} onClick={handleCloseUserMenu}>
                      <Link to={link.to}>{link.title}</Link>
                    </MenuItem>
                  ))
                )}
              </Menu>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
    </>
  );
};
